// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getObjectDifferences(obj1: any, obj2: any) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const diff = {} as any;
    const allKeys = Object.keys({ ...obj1, ...obj2 });

    allKeys.forEach(key => {
        if (obj1[key] !== obj2[key]) {
            diff[key] = obj2[key];
        }
    });

    return diff;
}
